import { render, staticRenderFns } from "./HousingIncomeList.vue?vue&type=template&id=5511be62"
import script from "./HousingIncomeList.vue?vue&type=script&lang=js"
export * from "./HousingIncomeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports